export const ACCOUNTS_RECEIVED = "ACCOUNTS_RECEIVED";
export const ACCOUNT_CREATED = "ACCOUNT_CREATED";
export const ACCOUNT_UPDATED = "ACCOUNT_UPDATED";
export const ACCOUNT_DELETED = "ACCOUNT_DELETED";
export const ACCOUNT_ACCESS_RECEIVED = "ACCOUNT_ACCESS_RECEIVED";
